import { BellSlashIcon } from "@heroicons/react/24/outline";


export function EmptyNotifications(props) {

    return (
        <div style={{ height: '4.375rem' }}>
            <div  style={{
                    padding:'0.3em',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }} >
                <BellSlashIcon className="w-4 h-auto" style={{ height: '2.5rem' }} />
                <span > No hay más notificaciones </span>
            </div>
           
        </div>
    )

}